(function () {
    'use strict';

    angular
        .module('elogbooks.admin.job-requisites')
        .controller('JobRequisitesSitesEditController', JobRequisitesSitesEditController);

    JobRequisitesSitesEditController.$inject = ['$stateParams', '$state', '$q', 'messenger', 'apiClient', 'lodash', 'jobRequisiteResponse'];

    function JobRequisitesSitesEditController ($stateParams, $state, $q, messenger, apiClient, lodash, jobRequisiteResponse) {
        var vm = this;
        vm.jobRequisite = jobRequisiteResponse;
        vm.multiSelect = {
            link: '/sites',
            selectedLink: vm.jobRequisite.getLink('sites'),
            selectedSearchKey: 'name',
            selectedSearchParams: { limit: 100 },
            selectedItems: [],
            pendingAdditions: [],
            pendingRemovals: [],
            responseKeyPath: 'sites',
            searchKey: 'siteName',
            searchParams: { status: 'active', limit: 100, order: 'name', notAttachedToJobRequisiteId: jobRequisiteResponse.id },
            loading: true,
            selectedLoading: true
        };

        $q.all([
            apiClient.get(vm.jobRequisite.getLink('sites'), { limit: 100, order: 'name' }),
            apiClient.get(vm.multiSelect.link, vm.multiSelect.searchParams)
        ]).then(function (results) {
            var selectedResponse = results[0];
            var response = results[1];

            if (!selectedResponse || !response) {
                return $q.reject();
            }

            vm.multiSelect.initialSelectedResponse = selectedResponse;
            vm.selectedSites = selectedResponse.sites;

            if (vm.selectedSites) {
                angular.forEach(vm.selectedSites, function (site) {
                    vm.multiSelect.selectedItems.push({href: site.getLink('self'), value: site.name});
                });
            }

            vm.multiSelect.selectedLoading = false;

            vm.multiSelect.initialResponse = response;
            vm.multiSelect.items = lodash.differenceBy(
                lodash.map(response.sites, function (site) {
                    return {href: site.getLink('self'), value: site.name};
                }),
                vm.multiSelect.selectedItems,
                'href'
            );
            vm.multiSelect.loading = false;
        }).catch(function () {
            vm.multiSelect.selectedLoading = false;
            vm.multiSelect.loading = false;
            vm.multiSelect.loadError = true;
            messenger.error('REQUEST_ERROR');
        });

        vm.pageTitle = 'JOB_REQUISITE_SITE_EDIT';
        vm.update = updateAction;

        function updateAction() {
            if (vm.updating || vm.multiSelect.loading || vm.multiSelect.selectedLoading || vm.multiSelect.loadError) {
                return;
            }

            var additions = vm.multiSelect.pendingAdditions || [];
            var removals = vm.multiSelect.pendingRemovals || [];

            if (!additions.length && !removals.length) {
                return $state.go('^', $stateParams, { reload: true }).then(function () {
                    messenger.success('JOB_REQUISITE_SITES_UPDATED');
                });
            }

            var modifySitesLink = vm.jobRequisite.getLink('modify-sites');

            if (!modifySitesLink) {
                messenger.error('REQUEST_ERROR');
                return;
            }

            vm.updating = true;

            var data = {
                _links: {
                    'added-site': additions,
                    'removed-site': removals
                }
            };

            apiClient.update(modifySitesLink, data).then(function (response) {
                if (response) {
                    return $state.go('^', $stateParams, { reload: true }).then(function () {
                        messenger.success('JOB_REQUISITE_SITES_UPDATED');
                    });
                } else {
                    messenger.error('REQUEST_ERROR');
                    vm.updating = false;
                }
            }).catch(function () {
                messenger.error('REQUEST_ERROR');
                vm.updating = false;
            });
        }
    }

})();
